export enum ReportFilterActionType {
  FilterReportDatasetSuccess = 'FilterReportDatasetSuccess',
  FilterReportDatasetFailure = 'FilterReportDatasetFailure',

  FilterReportDatasets = 'FilterReportDatasets',
  FilterReportDatasetsSuccess = 'FilterReportDatasetsSuccess',
  FilterReportDatasetsFailure = 'FilterReportDatasetsFailure',
}
